import {
  useCallback,
  useEffect,
  useMemo,
  useState,
  forwardRef,
  useImperativeHandle} from "react";
import {
  Checkbox} from "semantic-ui-react";
// Constants
import i18nstring, { strings } from "../../i18n";
import { ItemDayScheduled } from "../../Shared/Constants/Item";
// Theme
import "./MoleculeStyles.scss";


const initialDays = {};
Object.keys(ItemDayScheduled).forEach(day => {
  initialDays[day] = false;
});


export const PickupTimeWindow = forwardRef((props, ref) => {
  const [amDays, toggleAmDays] = useState();
  const [pmDays, togglePmDays] = useState();
  const dayLabels = useMemo(() => i18nstring(strings.DAY_LABELS) || {}, []);

  useEffect(() => {
    let tempAM = { ...initialDays };
    let tempPM = { ...initialDays };
    Object.values(props.deliverySchedule.AM).forEach(day => {
      tempAM[day] = true;
    });
    Object.values(props.deliverySchedule.PM).forEach(day => {
      tempPM[day] = true;
    });
    toggleAmDays(tempAM);
    togglePmDays(tempPM);
  }, [props.deliverySchedule]);

  const toggleDay = useCallback((period, day) => {
    const setter = period === "AM" ? toggleAmDays : togglePmDays;
    setter(currentDays => ({
      ...currentDays,
      [day]: !currentDays[day]
    }));
  }, []);

  useImperativeHandle(ref, () => ({
    async setSchedule() {
      const selectedDays = {
        AM: Object.keys(amDays || {}).filter(day => amDays[day] === true),
        PM: Object.keys(pmDays || {}).filter(day => pmDays[day] === true)
      };
      props.updateZipSchedule?.({
        deliverySchedule: selectedDays
      });
      return selectedDays;
    }
  }), [amDays, pmDays, props]);

  if (!amDays || !pmDays) return null;

  return (
    <div className="loc_form_hours_grid">
      <div className="loc_form_hours_row">
        <div className="loc_form_hours_period" />
        {Object.keys(ItemDayScheduled).map(day => (
          <div key={day} className="loc_form_hours_day_header">
            {dayLabels[day] || day}
          </div>
        ))}
      </div>
      <div className="loc_form_hours_row">
        <div className="loc_form_hours_period">
          {i18nstring(strings.AM_LABEL)}
        </div>
        {Object.keys(ItemDayScheduled).map(day => (
          <div key={`pickup-am-${day}`} className="loc_form_hours_cell">
            <Checkbox
              checked={amDays[day]}
              onChange={() => toggleDay("AM", day)}
            />
          </div>
        ))}
      </div>
      <div className="loc_form_hours_row">
        <div className="loc_form_hours_period">
          {i18nstring(strings.PM_LABEL)}
        </div>
        {Object.keys(ItemDayScheduled).map(day => (
          <div key={`pickup-pm-${day}`} className="loc_form_hours_cell">
            <Checkbox
              checked={pmDays[day]}
              onChange={() => toggleDay("PM", day)}
            />
          </div>
        ))}
      </div>
    </div>
  );
});

export const TimeWindow = forwardRef((props, ref) => {
  const [name, setName] = useState();
  const [amDays, toggleAmDays] = useState();
  const [pmDays, togglePmDays] = useState();

  useEffect(() => {
    let tempAM = { ...initialDays };
    let tempPM = { ...initialDays };
    Object.values(props.deliverySchedule.AM).forEach(day => {
      tempAM[day] = true;
    });
    Object.values(props.deliverySchedule.PM).forEach(day => {
      tempPM[day] = true;
    });
    toggleAmDays(tempAM);
    togglePmDays(tempPM);
    setName(props.selectedSchedule.name || "");
  }, [props.deliverySchedule, props.selectedSchedule.name]);

  const setAmDays = checkBox => {
    const daySelected = checkBox.target.previousSibling?.name;
    const newDays = { ...amDays };
    newDays[daySelected] = !amDays[daySelected];
    toggleAmDays(newDays);
  };

  const setPmDays = checkBox => {
    const daySelected = checkBox.target.previousSibling?.name;
    const newDays = { ...pmDays };
    newDays[daySelected] = !pmDays[daySelected];
    togglePmDays(newDays);
  };

  useImperativeHandle(ref, () => ({
    async setSchedule() {
      const selectedDays = {
        AM: Object.keys(amDays).filter(day => amDays[day] === true),
        PM: Object.keys(pmDays).filter(day => pmDays[day] === true)
      };
      if (!props.selectedSchedule.id) {
        return await props.createNewSchedule({ deliverySchedule: selectedDays, name });
      } else {
        props.updateSchedule({
          id: props.selectedSchedule.id,
          name,
          deliverySchedule: selectedDays
        });
      }
    }
  }))

  if (!amDays || !pmDays) return null;

  return (
    <div>
      <div className="time_scheduling">
        <DeliveryScheduleDays />
        <div className="time_scheduling_row">
          <div className="meredian_div">{i18nstring(strings.AM_LABEL)}</div>
          <Days days={amDays} toggleDay={setAmDays} />
        </div>
        <div className="time_scheduling_row">
          <div className="meredian_div">{i18nstring(strings.PM_LABEL)}</div>
          <Days days={pmDays} toggleDay={setPmDays} />
        </div>
      </div>
    </div>
  );
})

export function Days({ days, toggleDay }) {
  return Object.keys(days).map((day, index) => (
    <div key={index} className="time_scheduling_hours">
      <Checkbox name={day} checked={days[day]} onChange={toggleDay} />
    </div>
  ));
}

export function DeliveryScheduleDays() {
  const renderItemDays = () =>
    Object.values(i18nstring(strings.DayLabels)).map(day => (
      <div className="time_scheduling_hours" key={day}>
        <div>{day}</div>
      </div>
    ));
  return (
    <div className="time_scheduling_row">
      <div className="time_scheduling_hours_div">
        {i18nstring(strings.HOURS_LABEL)}
      </div>
      {renderItemDays()}
    </div>
  );
}